import { useContext, useState } from "react";
import { LangContext } from "../../../context/LangContext";
import { useFormatText } from "../../../hooks/useFormatText";

import Field from "./Field";
import PayPalCheckout from "../PayPalCheckout";

import "./style.css";

import stripe_logo from '../../../assets/img/stripe_logo.png';

function ChoosePayment({ setModal, cart, customerInfo, setCustomerInfo }) {
    const formatText = useFormatText();
    const { translations } = useContext(LangContext);

    const [error, setError] = useState("");
    const [isOpen, setIsOpen] = useState([true, false, false]);

    const setInfo = (field, e) => {
        setCustomerInfo({ ...customerInfo, [field]: e.target.value });
        if (error) setError("");
    };

    const checkBeforePayment = () => {
        const stringNoEmpty = v => typeof v === 'string' && v.trim() !== '';

        const allFilled = Object.values(customerInfo).every(stringNoEmpty);
        if (!allFilled) {
            setError('All fields required');
            setTimeout(() => setError(''), 2000);
            return
        }

        setIsOpen([false, false, !isOpen[2]]);
    }

    return (
        <form
            className="content choose_payment"
            onSubmit={(e) => e.preventDefault()}
        >
            <span className="title_mdl">payement</span>
            <p className="descrip">{formatText(translations.please_enter_your_email_address)}</p>

            <div className="blocks">
                <div className={`block ${isOpen[0] ? 'block_open' : ''}`}>
                    <button
                        type="button"
                        className="btn_open_block"
                        onClick={() => setIsOpen([!isOpen[0], false, false])}
                    >
                        <p>{translations.contact}</p>
                        <i className="fas fa-chevron-down"></i>
                    </button>

                    <div className="container">
                        <div className="fields">
                            <Field
                                label={translations.lastname}
                                value={customerInfo.lastname}
                                holder="Martin"
                                field="lastname"
                                setInfo={setInfo}
                            />

                            <Field
                                label={translations.firstname}
                                value={customerInfo.firstname}
                                holder="Jean"
                                field="firstname"
                                setInfo={setInfo}
                            />
                        </div>

                        <Field
                            label="E-mail"
                            value={customerInfo.email}
                            holder="jean.martin@exemple.com"
                            field="email"
                            setInfo={setInfo}
                        />
                    </div>
                </div>

                <div className={`block ${isOpen[1] ? 'block_open' : ''}`}>
                    <button
                        type="button"
                        className="btn_open_block"
                        onClick={() => setIsOpen([false, !isOpen[1], false])}
                    >
                        <p>{translations.delivery}</p>
                        <i className="fas fa-chevron-down"></i>
                    </button>

                    <div className="container">
                        <div className="fields_mobile">
                            <Field
                                label={translations.address}
                                value={customerInfo.address}
                                holder="10 rue de la liberté"
                                field="address"
                                setInfo={setInfo}
                            />
                        </div>

                        <div className="fields fields_mobile">
                            <Field
                                label={translations.city}
                                value={customerInfo.city}
                                holder="Paris"
                                field="city"
                                setInfo={setInfo}
                            />

                            <Field
                                label={translations.country}
                                value={customerInfo.country}
                                holder="France"
                                field="country"
                                setInfo={setInfo}
                            />
                        </div>

                        <div className="fields fields_mobile">
                            <Field
                                label={translations.zip_code}
                                value={customerInfo.zip_code}
                                holder="75001"
                                field="zip_code"
                                setInfo={setInfo}
                            />

                            <i />
                        </div>

                        <div className="fields fields_desktop">
                            <Field
                                label={translations.address}
                                value={customerInfo.address}
                                holder="10 rue de la liberté"
                                field="address"
                                setInfo={setInfo}
                            />

                            <Field
                                label={translations.city}
                                value={customerInfo.city}
                                holder="Paris"
                                field="city"
                                setInfo={setInfo}
                            />
                        </div>

                        <div className="fields fields_desktop">
                            <Field
                                label={translations.country}
                                value={customerInfo.country}
                                holder="France"
                                field="country"
                                setInfo={setInfo}
                            />

                            <Field
                                label={translations.zip_code}
                                value={customerInfo.zip_code}
                                holder="75001"
                                field="zip_code"
                                setInfo={setInfo}
                            />
                        </div>
                    </div>
                </div>

                <div className={`block ${isOpen[2] ? 'block_open' : ''}`}>
                    <button
                        type="button"
                        className="btn_open_block"
                        onClick={() => checkBeforePayment()}
                    >
                        <p>{translations.payment_method}</p>
                        <i className="fas fa-chevron-down"></i>
                    </button>

                    <div className="panel_payement">
                        <button type="button" onClick={() => setModal("stripe")}>
                            <img src={stripe_logo} alt="Stripe" />
                        </button>

                        <PayPalCheckout setModal={setModal} cart={cart} customerInfo={customerInfo} />
                    </div>
                </div>
            </div>

            {error && <p className="error_msg">{error}</p>}

            <div className="panel_modal">
                <button
                    type="button"
                    className="btn_close"
                    onClick={() => setModal(null)}
                >{translations.cancel}</button>
            </div>
        </form>
    );
}

export default ChoosePayment;